<template>
  <ul
    class="vertical-scroll"
    :style="{ height }"
  >
    <transition
      v-for="(item, index) in listData"
      :key="index"
      name="slide-top"
      mode="out-in"
    >
      <li
        v-show="index === activeIndex"
        v-expose="{
          id: 'notify_' + index,
          callback: () => {
            reportMV(item);
          },
        }"
        class="main-info"
        :style="{ paddingBottom: item.subText ? '' : paddingBottom }"
        @click="openPage(item)"
      >
        <div>
          <p class="title ellipsis">
            {{ item.text }}
          </p>
          <p
            v-if="item.subText"
            class="subtitle ellipsis"
          >
            {{ item.subText }}
          </p>
        </div>
        <i
          v-if="item.url"
          class="arrow-icon"
        ></i>
      </li>
    </transition>
  </ul>
</template>

<script lang="ts">
import Vue from 'vue';
import { bridge, env, NoemaType } from '@/common';
import { lx } from '@/analytic';
import { cids, bids } from '@/analytic/lx-constants';

export default Vue.extend({
  name: 'VerticalScroll',

  props: {
    listData: {
      default: () => [] as NotifyType[],
      type: Array as () => NotifyType[],
    },
  },

  data() {
    return {
      activeIndex: 0,
    };
  },

  computed: {
    height(): string {
      return this.listData.some((item: any) => item.subText) ? '.7rem' : '.36rem';
    },

    paddingBottom(): string {
      const multiData = this.listData?.length > 1;
      const paddingBottom = this.listData.some((item: any) => item.subText) ? '.34rem' : '0';
      return multiData ? paddingBottom : '0';
    },
  },

  mounted() {
    const timeCount = window.setInterval(() => {
      if (this.activeIndex === this.listData.length - 1) {
        this.activeIndex = 0;
      } else {
        this.activeIndex += 1;
      }
    }, 2000);
    this.$once('hook:beforeDestroy', () => {
      window.clearInterval(timeCount);
    });
  },

  methods: {
    openPage(item: any) {
      if (!item.url) return;
      lx.addTag(cids.result, env.resultLxCommonParams, {
        bid: bids.noema.mc,
        type: NoemaType.Notify,
        notice_id: '-999',
        notice_type: item.notifyType || '-999',
      });
      lx.mc(bids.noema.mc, {
        ...env.resultLxCommonParams,
        notice_id: '-999',
        type: NoemaType.Notify,
        notice_type: item.notifyType || '-999',
      });
      bridge.openPage(item.url);
    },

    reportMV(item: any) {
      lx.mv(bids.noema.mv, {
        ...env.resultLxCommonParams,
        notice_id: '-999',
        type: NoemaType.Notify,
        notice_type: item.notifyType || '-999',
      });
    },
  },
});
</script>

<style lang="less" scoped>
.vertical-scroll {
  position: relative;
  flex: 1;
  overflow: hidden;

  li {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    align-items: center;
  }
}

.slide-top-enter-active,
.slide-top-leave-active {
  transition: transform 0.5s linear;
}
.slide-top-enter {
  transform: translateY(100%);
}
.slide-top-enter-to,
.slide-top-leave {
  transform: translateY(0);
}
.slide-top-leave-to {
  transform: translateY(-100%);
}
</style>
